import './footerContact.scss';

import React, { FunctionComponent } from 'react';


import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useTranslation } from 'react-i18next';
import { Icon, LocalizedLink } from '../../primitives';

type FooterPhoneContactProps = {
    contactInformation: Queries.contactUsInformationFragmentFragment;
    contactType: 'CustomerService' | 'TechnicalSupport';
};

export const FooterContact: FunctionComponent<FooterPhoneContactProps> = (
    props: FooterPhoneContactProps
) => {
    const { contactInformation, contactType } = props;

    const { currentLocale } = usePageLocalization();
    const { t } = useTranslation('mainLayout');

    const title = contactInformation?.title?.[currentLocale];

    const phone =
        contactInformation?.attributes?.texte_1?.values?.[0]?.[currentLocale];

    const openingDays =
        contactInformation?.attributes?.texte_2?.values?.[0]?.[currentLocale];

    const openingHours =
        contactInformation?.attributes?.texte_3?.values?.[0]?.[currentLocale];

    return (
        <div className='footer-phone-contact'>
            {title}
            <div className='footer-logo-item '>
                <Icon
                    d='M.068,4.425A2.921,2.921,0,0,0,.362,5.7,25.873,25.873,0,0,0,5.33,12.608a25.871,25.871,0,0,0,6.905,4.969A2.948,2.948,0,0,0,15.605,17l2.328-2.344L13.148,9.9l-1.908,1.884A13.5,13.5,0,0,1,8.423,9.6,13.293,13.293,0,0,1,6.254,6.8L8.139,4.854,3.277,0,.936,2.333A2.958,2.958,0,0,0,.068,4.425ZM1.921,3.32,3.276,1.97l2.9,2.9-1.6,1.657.189.429A13.264,13.264,0,0,0,7.436,10.59a13.5,13.5,0,0,0,3.647,2.687l.435.194,1.626-1.6,2.817,2.8-1.344,1.353a1.552,1.552,0,0,1-1.772.3,24.46,24.46,0,0,1-6.528-4.7,24.461,24.461,0,0,1-4.7-6.528A1.553,1.553,0,0,1,1.921,3.32Z'
                    size='18'
                    viewBox='0 0 17.865 17.87'
                    transform='translate(-0.068)'
                />
                <a href={`tel:${phone}`}>{phone}</a>
            </div>
            <p>
                {openingDays}
                <br />
                {openingHours}
            </p>
            <div className='footer-logo-item'>
                <Icon
                    d='M0,88v13.74H18.562V88Zm16.705.977L9.281,95.645,1.857,88.977Zm-15.618.691,5.793,5.2-5.793,5.2Zm.769,11.1,5.793-5.2,1.631,1.465,1.631-1.465,5.793,5.2Zm15.618-.691-5.793-5.2,5.793-5.2Z'
                    size='18'
                    viewBox='0 0 18.562 13.74'
                    transform='translate(0 -88)'
                />
                <LocalizedLink
                    to={`/contact-us/${
                        contactType === 'CustomerService'
                            ? 'customer-service'
                            : 'technical-support'
                    }`}
                >
                    <>{t('contact-us') || 'Contact Us'}</>
                </LocalizedLink>
            </div>
        </div>
    );
};
